import { SelectionColumn, ExpanderColumn, ActionsColumn, ToolsColumn} from "./columns";

export const initRowState = (data, columns) => {
  if(data?.length && columns?.length) {
    let rowState = {};
    data.forEach((element, index) => {
      let cellState = {};
      columns.forEach((item, idx) => {
        cellState[item.Header] = item;
      });
      rowState[index + ""] = { ...element, cellState }
    });
    return rowState;
  }
  
  return {}
};

export const cellRenderCallBack = ( instanceRowState, row, cell ) => {
  const rowId = cell.row.id;
  const cumId = cell.column.id;
  const row_state = instanceRowState.state.rowState;

  if (cumId === "expander") {
    if (cell?.column?.Cell) {
      return cell.column.Cell(cell)
    };
    return ""
  };

  if (row_state && row_state[rowId] && row_state[rowId][cumId]) {
    return row_state[rowId][cumId]
  } else if (cell?.state?.Cell) {
    return cell.state.Cell(cell)
  };
  return ""
};

/**
 * 是否有默认配置的操作columns 
 * @param { Array } columns 原有的 columns
 * @param { Object } actions 用户配置的 actions
 * @param { Object} expander 用户配置的 expander
 * @param { Object } selection 用户配置的 selection
 * @param { Object } tools 用户配置的tools
 * @param { reactRef } ref drawn 的ref
 * @returns Array columns的新配置
 */
export const getColumns = (props) => {
  const { columns, actions, expander, selection, tools, ref } = props;
  
  let allColumns = columns;

  // left icons column
  if (actions) {
    allColumns = [ActionsColumn(props), ...allColumns];
  };

  // is expander column
  if (expander) {
    allColumns = [ExpanderColumn(), ...allColumns];
  };

  // selection column
  if (selection) {
    allColumns = [SelectionColumn(), ...allColumns]
  }
  // right tools column
  if (tools) {
    allColumns = [ToolsColumn( ref ), ...allColumns]
  };

  return allColumns;
};